import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { FullExperience } from '@/schemas/experience-schema.ts';
import experienceTagStore from '@store/experience-tag-store.ts';
import modalStore from '@store/modal-store.ts';
import toastStore from '@store/toast-store.ts';
import { ToastType } from '@components/service/toast/toast-enums.ts';
import { PopulatedExperienceTag } from '@/schemas/experience-tag-schema.ts';
import ModalBase from '@components/modal/modal-base.tsx';
import experienceStatsStore from '@store/experience-stats-store.ts';
import averagePlaytimeStatsStore from '@store/experience-stats/average-playtime-stats-store.ts';

interface ExperienceTagDetailsRemoveExperienceModalProps {
	tag: PopulatedExperienceTag;
	experience: FullExperience;
}

const ExperienceTagDetailsRemoveExperienceModal = observer(
	function ExperienceTagDetailsRemoveExperienceModal(
		props: ExperienceTagDetailsRemoveExperienceModalProps
	) {
		const [deletingExperience, setDeletingExperience] = useState(false);

		const deleteExperience = async () => {
			setDeletingExperience(true);
			await experienceTagStore.deleteExperienceIdFromTag(
				props.tag.id,
				props.experience.place_id
			);
			experienceStatsStore.clearTagCCU(props.tag);
			averagePlaytimeStatsStore.clearTagPlaytime(props.tag.id);
			modalStore.close();
			setDeletingExperience(false);
			toastStore.emit(
				`Successfully removed experience from tag`,
				ToastType.CONFIRM
			);
		};

		return (
			<ModalBase
				title={`Remove experience from tag`}
				content={{
					description: `Are you sure you want to remove "${props.experience.name}" from the tag "${props.tag.name}"?`,
				}}
				onConfirm={deleteExperience}
				options={{
					confirmButtonTitle: 'Remove',
				}}
				loadingSubmit={deletingExperience}
			/>
		);
	}
);

export default ExperienceTagDetailsRemoveExperienceModal;
